import { useEffect, useRef } from 'react';
import { guideAnsichtSteuerung, useGuideAnsichtSteuerung } from '../lib/guideAnsichtSteuerung';
import { schnellKnoepfe } from './guide-oberthemen';
import './GuideSchnellwahl.css';

/** Wie lange „Ansicht gesetzt“ stehen bleibt. */
export const MELDUNG_MS = 10_000;

/**
 * SCHNELLWAHL IM DOCK (Rafael, 24.10.2026: „er muss schnell sein“): Abkuerzungen fuer die Ziele-Ansicht oben — Alle, Wartet auf dich, Pausiert und die ersten Oberthemen.
 * Ein Klick setzt Auswahl/Filter direkt im Client (kein Modell, kein Server) und schaltet die Ansicht oben bewusst auf „Ziele (neu)“. Gilt nur im eigenen Fenster; fuer
 * jede Nutzerart gleich. Darueber steht fuer ca. 10 s „Ansicht gesetzt: … · Rueckgaengig“.
 */
export function GuideSchnellwahl() {
  const st = useGuideAnsichtSteuerung();
  const knoepfe = schnellKnoepfe(st.ziele, st.auswahl, st.filter);
  const ersterKnopf = useRef<HTMLButtonElement>(null);
  const nr = st.meldung?.nr;
  useEffect(() => {
    if (nr === undefined) return;
    const t = setTimeout(() => guideAnsichtSteuerung.meldungSchliessen(nr), MELDUNG_MS);
    return () => clearTimeout(t);
  }, [nr]);
  return (
    <div className="gs-wrap" data-ai-id="guide-schnellwahl">
      {st.meldung && (
        <div className="gs-meldung" role="status" data-ai-id="guide-schnellwahl-meldung">
          <span className="gs-meldung-text">Ansicht gesetzt: {st.meldung.text}</span>
          {st.meldung.original !== undefined && (
            <button type="button" className="gs-rueck" data-ai-id="guide-schnellwahl-als-nachricht" title="Das war eine Nachricht: Ansicht zurück, Text zurück ins Eingabefeld (wird nicht automatisch gesendet)"
              onClick={() => guideAnsichtSteuerung.alsNachricht()}>Als Nachricht senden</button>
          )}
          {st.vorher && (
            <button type="button" className="gs-rueck" data-ai-id="guide-schnellwahl-rueckgaengig"
              onClick={() => { guideAnsichtSteuerung.rueckgaengig(); ersterKnopf.current?.focus(); }}>Rückgängig</button>
          )}
        </div>
      )}
      <div className="gs-zeile" role="group" aria-label="Schnellwahl für die Ansicht oben">
        {knoepfe.map((k, i) => (
          <button key={k.id} ref={i === 0 ? ersterKnopf : undefined} type="button" className="gs-knopf" data-ai-id={`guide-schnell-${k.id}`}
            aria-pressed={k.pressed && st.ansicht !== 'raum'} title={k.titel}
            onClick={() => guideAnsichtSteuerung.befehl(k.wert, k.beschreibung)}>{k.label}</button>
        ))}
      </div>
    </div>
  );
}
